import { render, staticRenderFns } from "./backoffice-suprimentos.vue?vue&type=template&id=83f589f2&scoped=true"
import script from "./backoffice-suprimentos.vue?vue&type=script&lang=ts"
export * from "./backoffice-suprimentos.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-suprimentos.vue?vue&type=style&index=0&id=83f589f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f589f2",
  null
  
)

export default component.exports